import axios from 'axios';
import { getAdminCustomTableConfigurationQuery } from './queries';

const getAdminCustomTableConfiguration = (tableName) =>
    new Promise((resolve, reject) => {
        const query = getAdminCustomTableConfigurationQuery({ tableName });
        const request = axios.get(query);

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getAdminCustomTableConfiguration;
